export class PlaceFilterForm {
  networkContractId?: number;
  code: string;
  client: string;
  countyId: number;
  cityId: number;
  clientCode: string;
  clientType: string;
  placeType: string;

  pageSize = 10;
  pageOffset = 0;
}
